'use client';

import React, { useState } from 'react';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface VideoTestimonialProps {
  video: {
    id: number;
    customerName: string;
    location: string;
    thumbnailUrl: string;
    thumbnailAlt: string;
    videoUrl: string;
    duration: string;
    puppyVariety: string;
  };
}

const VideoTestimonial = ({ video }: VideoTestimonialProps) => {
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlay = () => {
    setIsPlaying(true);
  };

  return (
    <div className="overflow-hidden rounded-xl bg-card shadow-warm transition-smooth hover:shadow-warm-md">
      <div className="relative aspect-video">
        {!isPlaying ? (
          <>
            <AppImage
              src={video.thumbnailUrl}
              alt={video.thumbnailAlt}
              className="h-full w-full object-cover"
            />
            <div className="absolute inset-0 flex items-center justify-center bg-foreground/40">
              <button
                onClick={handlePlay}
                className="flex h-20 w-20 items-center justify-center rounded-full bg-accent shadow-warm-lg transition-smooth hover:scale-110 hover:bg-accent/90 focus:outline-none focus:ring-3 focus:ring-ring focus:ring-offset-3"
                aria-label="Play video testimonial"
              >
                <Icon
                  name="PlayIcon"
                  size={32}
                  variant="solid"
                  className="ml-1 text-accent-foreground"
                />
              </button>
            </div>
            <div className="absolute bottom-4 right-4 rounded-md bg-foreground/80 px-3 py-1 caption font-medium text-background">
              {video.duration}
            </div>
          </>
        ) : (
          <iframe
            src={video.videoUrl}
            title={`Video testimonial from ${video.customerName}`}
            className="h-full w-full"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        )}
      </div>

      <div className="p-5">
        <h4 className="mb-1 font-heading text-lg font-semibold text-foreground">
          {video.customerName}
        </h4>
        <p className="caption mb-3 text-muted-foreground">{video.location}</p>
        <div className="flex items-center gap-2 rounded-lg bg-primary/10 px-3 py-2">
          <Icon name="HeartIcon" size={16} variant="solid" className="text-accent" />
          <span className="caption font-medium text-primary">
            {video.puppyVariety} Labrador
          </span>
        </div>
      </div>
    </div>
  );
};

export default VideoTestimonial;